import {AiOutlineInstagram} from 'react-icons/ai'
import {FaXTwitter} from 'react-icons/fa6'
import {AiFillFacebook} from 'react-icons/ai'
import {AiFillLinkedin} from 'react-icons/ai'

const data = [
    {id: 1, link: 'https://www.linkedin.com/in/josephattardfava/', icon: <AiFillLinkedin/>},
    {id: 2, link: 'https://www.instagram.com/joseph.af92', icon: <AiOutlineInstagram/>},
    {id: 3, link: 'https://x.com/joseph_af92', icon: <FaXTwitter/>},
    {id: 4, link: 'https://www.facebook.com/josephattardfava', icon: <AiFillFacebook/>}
]

export default data